 export enum DemandeDpaeEtatEnum {
ARealiser = 0,
Envoyee = 1,
NonConforme = 2,
Conforme = 3,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/DemandeDpaeEtatEnum.ts